module.exports = __webpack_public_path__ + "static/media/tiktok-h5.8772ca2c.png";